import { render, staticRenderFns } from "./bought.vue?vue&type=template&id=4b588808&scoped=true"
import script from "./bought.vue?vue&type=script&lang=js"
export * from "./bought.vue?vue&type=script&lang=js"
import style0 from "./bought.vue?vue&type=style&index=0&id=4b588808&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b588808",
  null
  
)

export default component.exports